<script setup lang="ts">
defineProps<{
  progress: number
  barClass?: string
}>()
</script>

<template>
  <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
    <div
      class="animated-progress h-4 rounded-full bg-primary transition-[width] duration-1000"
      :class="barClass"
      :style="{ width: `${Math.max(0, Math.min(100, progress))}%` }"
    />
  </div>
</template>
